/**
 * Returns `true` when the `:customerId` URL param matches one of the known
 * checkout step path segments (e.g. `"pay"`, `"sign"`).
 *
 * This happens when the router receives a URL that is missing the customer ID
 * segment entirely (e.g. `/checkout/pay` instead of
 * `/checkout/:orderId/:customerId/pay`), causing the step name to be captured
 * as `customerId`. Dispatching an API call with this value would produce an
 * error; callers should redirect to `/` immediately.
 *
 * @param customerId - The value extracted from the `:customerId` route param.
 * @param stepPaths  - The list of known checkout step path segments to check
 *                     against (excludes the catch-all `"*"` route).
 */
export function isInvalidCheckoutCustomerId(customerId: string, stepPaths: string[]): boolean {
  return stepPaths.includes(customerId);
}
